









import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { INumberStyle, NumberFormatKinds } from "../../../../../documaker/domain/format/objects";

@Component({
  components: {
    OptionDropDownSelector,
  }
})
export default class NumberStyleEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: INumberStyle) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: INumberStyle) => T, defaultValue: T) => T;
  
  get formatKind(): NumberFormatKinds {
    return this.readPropertyOrDefault(s => s.formatKind, NumberFormatKinds.None);
  }

  set formatKind(value: NumberFormatKinds) {
    this.writePropertyWhenValid(s => s.formatKind = value);
  }

  formatKindOptions: StandardOption<number>[] = [
    new StandardOption<number>("指定しない", NumberFormatKinds.None),
    new StandardOption<number>("金額表示(#,###)", NumberFormatKinds.Money),
  ];
}
